import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import { clientRoute } from '../route';

import { marketingActionsValidateSearchSchema } from './marketingActionsValidateSearchSchema';

export const clientMarketingActionsRoute = createRoute({
	getParentRoute: () => clientRoute,
	path: '/marketing-actions',
	component: lazyRouteComponent(
		() => import('./ClientMarketingActionsPage'),
		'ClientMarketingActionsPage',
	),
	validateSearch: marketingActionsValidateSearchSchema,
});
